import { getAuth } from 'firebase/auth';
import { toJson } from './firebase';

export const auth = getAuth();

console.log(
  toJson({
    status: 'initialising auth',
  })
);
